import styles from './LanguageFrameworks.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

export type LanguageFrameworksItems = {
  category: string
  items: {
    src: string
    alt: string
  }[]
}

interface Props {
  languageFrameworksList: LanguageFrameworksItems[]
}

const LanguageFrameworks: React.FC<Props> = ({ languageFrameworksList }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.container} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>主な利用技術・ツール</h2>
      <p className={styles.sectionRead}>
        幅広いプロジェクトに対応するために、実績ある最新の技術やツールを積極的に活用しています
      </p>

      <div className={styles.stack}>
        {languageFrameworksList.map((LanguageFrameworksItem, index) => (
          <section key={index} className={`${styles.stack__group} ${styles[`group${index + 1}`]}`}>
            <div className={styles.stack__group__category}>
              <span className={styles.stack__group__category__red}></span>
              <h3 className={styles.stack__group__category__title}>{LanguageFrameworksItem.category}</h3>
            </div>
            <div className={styles.stack__group__icon}>
              {LanguageFrameworksItem.items.map((item) => (
                <div key={item.alt} className={styles.stack__group__icon__item}>
                  <figure className={styles.stack__group__icon__item__img}>
                    <img src={item.src} alt={item.alt} />
                  </figure>
                  <p className={styles.stack__group__icon__item__name}>{item.alt}</p>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
      <section className={styles.products}>
        <h3 className={styles.products__title}>自社製品・サービス</h3>
        <div className={styles.wrapper}>
          <article className={styles.products__item}>
            <a
              href="https://phennec.ai/"
              target="_blank"
              rel="noopener"
              className={`${styles.products__item__link} ${styles.another}`}
            >
              <figure className={styles.products__item__link__img}>
                <img
                  src="/img/common/logo_phennec.svg"
                  alt="Phennec"
                  width={145}
                  height={26}
                  className={styles.img_phennec}
                />
              </figure>
              <div className={styles.products__item__link__cts}>
                <h4 className={styles.products__item__link__cts__title}>Phennec</h4>
                <p className={styles.products__item__link__cts__text}>
                  AIエージェントの真価を引き出す「コンテキスト・エンジニアリング」基盤
                </p>
              </div>
            </a>
          </article>
          <article className={styles.products__item}>
            <a
              href="/products/flamingo/"
              target="_blank"
              rel="noopener"
              className={`${styles.products__item__link} ${styles.another}`}
            >
              <figure className={styles.products__item__link__img}>
                <img
                  src="/img/common/logo_flamingo.svg"
                  alt="Flamingo"
                  width={128}
                  height={32}
                  className={styles.img_flamingo}
                />
              </figure>
              <div className={styles.products__item__link__cts}>
                <h4 className={styles.products__item__link__cts__title}>flamingo</h4>
                <p className={styles.products__item__link__cts__text}>
                  ウェブシステムのUX/UIデザインをモダナイズするSaaS
                </p>
              </div>
            </a>
          </article>
          <article className={styles.products__item}>
            <a href="/products/zebra/" rel="noopener" className={`${styles.products__item__link} ${styles.self}`}>
              <figure className={styles.products__item__link__img}>
                <img
                  src="/img/common/logo_zebra.svg"
                  alt="ZEBRA"
                  width={142}
                  height={32}
                  className={styles.img_zebra}
                />
              </figure>
              <div className={styles.products__item__link__cts}>
                <h4 className={styles.products__item__link__cts__title}>ZEBRA</h4>
                <p className={styles.products__item__link__cts__text}>
                  最適にセグメント配信可能なCRM型のプッシュ通知エンジン
                </p>
              </div>
            </a>
          </article>
          <article className={styles.products__item}>
            <a
              href="https://eland.jp/"
              target="_blank"
              rel="noopener"
              className={`${styles.products__item__link} ${styles.another}`}
            >
              <figure className={styles.products__item__link__img}>
                <img
                  src="/img/common/logo_eland.svg"
                  alt="ELAND"
                  width={102}
                  height={20}
                  className={styles.img_eland}
                />
              </figure>
              <div className={styles.products__item__link__cts}>
                <h4 className={styles.products__item__link__cts__title}>ELAND</h4>
                <p className={styles.products__item__link__cts__text}>
                  モダン開発のプロが作った高スキルエンジニアの人材データベース
                </p>
              </div>
            </a>
          </article>
        </div>
      </section>
    </section>
  )
}

export default LanguageFrameworks
